import avisynth from "refractor/avisynth";
export default avisynth;